import script from "./AbasFormulario.vue?vue&type=script&setup=true&lang=js"
export * from "./AbasFormulario.vue?vue&type=script&setup=true&lang=js"

import "./AbasFormulario.vue?vue&type=style&index=0&id=08ba1d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ba1d54"]])

export default __exports__